import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { D3TooltipComponent } from './d3-tooltip.component';
import { D3TooltipService } from './d3-tooltip.service';
import { D3TooltipHostDirective } from './d3-tooltip-host.directive';

export { D3TooltipHostDirective } from './d3-tooltip-host.directive';
export { D3TooltipComponent } from './d3-tooltip.component';
export { D3TooltipService, ITooltipOptions, ITooltipPosition } from './d3-tooltip.service';
export class D3TooltipModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  entryComponents: [D3TooltipComponent],
  declarations: [D3TooltipComponent, D3TooltipHostDirective],
  providers: [D3TooltipService],
  exports: [D3TooltipComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function D3TooltipModule_tsickle_Closure_declarations() {
/** @type {?} */
D3TooltipModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
D3TooltipModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
